export const fontSizeToggleAction = {
    type: "fontSizeEnabled",
    payload: false,
    enabled: false
};